import Part from "@/components/body/parts/part";
import { Colors } from "@/components/shared/util";
import { Patient } from "@/store/modules/patient/types";
import SVG from "svg.js";
import { Store } from "vuex";
import { BodyConfig } from ".";

const chestTubeOuterId = "#chestTubeOuter";
export default class ChestTube extends Part {
  chestTubeOuter: SVG.Element;

  constructor(config: BodyConfig, container: SVG.Container, store: Store<any>) {
    super(config, container, store);
    this.chestTubeOuter = SVG.select(
      chestTubeOuterId,
      this.container.node
    ).first();
  }

  updateData(patient: Patient | null) {
    super.updateData(patient);

    if (this.atom && this.atom.age >= 0 && this.atom.age < 86400) {
      this.show();
      const color = this.atom.alert ? Colors.Red : Colors.Green;
      this.levelElements.forEach(element => {
        element.fill({ color });
      });
    } else {
      this.hide();
    }
  }

  updateBrightnessMode() {
    if (this.dark) {
      this.chestTubeOuter.fill({ color: Colors.DarkMode });
    } else {
      this.chestTubeOuter.fill({ color: Colors.LightMode });
    }
  }
}
